import DOCUMENTVERIFIED from "../../assets/Document verified - Iconly Pro.png";
import FOCUS from "../../assets/Focus frame - Iconly Pro.png";
import STARS from "../../assets/stars - Iconly Pro.png";
import BRAIN from "../../assets/Brain - Iconly Pro.png";
import LOCK from "../../assets/Lock - Iconly Pro.png";

import SHEILDPROFILE from "../../assets/Shield profile - Iconly Pro.png";
import PEN from "../../assets/Pen - Iconly Pro.png";
import DOCUMENT from "../../assets/Document - Iconly Pro.png";

import TRNASLATE from "../../assets/Translate language - Iconly Pro.png";
import DISCOUNT from "../../assets/Discount - Iconly Pro.png";
import FLASH from "../../assets/Flash - Iconly Pro.png";
import SCALE from "../../assets/Scale - Iconly Pro.png";
import SITEMAP from "../../assets/Sitemap - Iconly Pro.png";

import IMG from "../../assets/container.png";
import PIC from "../../assets/Pic.png";

import STAT from "../../assets/legal-Stat-1.png";
import STAT2 from "../../assets/legal-Stat-2.png";

import ASESMENT1 from "../../assets/legal-asesment.png";
import ASESMENT2 from "../../assets/legal-asesment-1.png";
import ASESMENT3 from "../../assets/legal-asesment-2.png";
import ASESMENT4 from "../../assets/legal-asesment-3.png";
import ASESMENT5 from "../../assets/legal-asesment-4.png";

import LEGAL_TRANSLATION_IMG from "../../assets/legal-translation-img.png";
import LEGAL_SECTION4_MOBILEIMG from "../../assets/legal-section4-MobileImg.png"
import LEGAL_SECTION4_BGIMG from "../../assets/legal-section4-BgImg.png"
import LOGO from "../../assets/logo.png";

export const IMAGES = {
    DOCUMENTVERIFIED,
    SHEILDPROFILE,
    PEN,
    DOCUMENT,
    TRNASLATE,
    DISCOUNT,
    FLASH,
    SCALE,
    SITEMAP,
    FOCUS,
    STARS,
    BRAIN,
    LOCK,
    IMG,
    PIC,
    STAT,
    STAT2,
    ASESMENT1,
    ASESMENT2,
    ASESMENT3,
    ASESMENT4,
    ASESMENT5,
    LEGAL_TRANSLATION_IMG,
    LOGO,
    LEGAL_SECTION4_MOBILEIMG,
    LEGAL_SECTION4_BGIMG
};
